export const SERVER_MENU_SETTINGS_PERMISSIONS = [
  "AssignRoles",
  "BanMembers",
  "KickMembers",
  "ManageChannel",
  "ManageCustomisation",
  "ManageNicknames",
  "ManagePermissions",
  "ManageRole",
  "ManageServer",
  "ManageWebhooks",
] as const;

type ServerMenuPermission =
  | (typeof SERVER_MENU_SETTINGS_PERMISSIONS)[number]
  | "ChangeNickname"
  | "ChangeAvatar";

interface ServerMenuPermissionInput {
  isOwner: boolean;
  hasInvitableChannel: boolean;
  permissions: readonly ServerMenuPermission[];
}

export function getServerMenuCapabilities(input: ServerMenuPermissionInput) {
  const permissions = new Set(input.permissions);

  return {
    invite: input.hasInvitableChannel,
    editIdentity:
      permissions.has("ChangeNickname") || permissions.has("ChangeAvatar"),
    settings:
      input.isOwner ||
      SERVER_MENU_SETTINGS_PERMISSIONS.some((permission) =>
        permissions.has(permission),
      ),
    leave: !input.isOwner,
  };
}
